import { BursonServiceAjs }         from './burson.service.ajs';
import { CodeTypeModel }            from '../../app-lite/core/models/code-type';
import { CompanyIntegrationsModel } from '../../app-lite/companies/models/company.integrations';
import { UserModel }                from '../../app-lite/users/models/user';
import { VendorModel }              from '../../app-lite/vendors/models/vendor';

import VendorSearchResultsHtml from '../../app-lite/vendors/templates/vendors.search.results.html';

interface BursonSettingsScope extends ng.IScope {
  activate                     : () => void;
  deactivate                   : () => void;
  form                         : ng.IFormController;
  isUpgraded                   : () => boolean;
  loaded                       : boolean;
  priceOptions                 : Array<CodeTypeModel>;
  save                         : () => void;
  settings                     : CompanyIntegrationsModel;
  shouldShowAutoDownloadMessage: () => boolean;
  user                         : UserModel;
  vendorSearch                 : any;
}

export function BursonSettingsCtrl (
  $rootScope  : any,
  $scope      : BursonSettingsScope,
  $state      : ng.ui.IStateService,
  $translate  : ng.translate.ITranslateService,
  bursonApi   : BursonServiceAjs,
  confirm     : any,
  messages    : any,
  settings    : CompanyIntegrationsModel,
  streamSearch: any,
  user        : UserModel,
  Vendor      : any
) {

  $scope.loaded   = true;
  $scope.settings = settings;
  $scope.user     = user;

  $scope.priceOptions = [
    {
      code          : 'NOTHING',
      description   : 'Dont change the price',
      language_label: $translate.instant('JS_SPACE.BURSON.DONT_CHANGE_THE_PRICE')
    },
    {
      code          : 'DIFFERENT',
      description   : 'Update to Burson\'s price, if price is different',
      language_label: $translate.instant('JS_SPACE.BURSON.PRICE_IS_DIFFERENT')
    },
    {
      code          : 'HIGHER',
      description   : 'Update to Burson\'s price, if price higher in Burson',
      language_label: $translate.instant('JS_SPACE.BURSON.PRICE_HIGHER')
    },
    {
      code          : 'ALL',
      description   : 'Always use Burson\'s Price',
      language_label: $translate.instant('JS_SPACE.BURSON.ALWAYS_USE_BURSON_PRICE')
    }
  ];

  $scope.vendorSearch = {
    choose ( vendor : VendorModel ) {
      $scope.settings.burson_ezyparts_vendor_id   = vendor.id;
    },
    format ( vendor : VendorModel ) {
      return vendor ? vendor.company_name: '';
    },
    list: [],
    new () {
      const self = this;

      Vendor.quickAdd()
      .then(( vendor : VendorModel ) => {
        self.selected = vendor;

        $scope.settings.burson_ezyparts_vendor_id   = vendor.id;

        messages.show($translate.instant('JS_SPACE.INTEGRATIONS.SUPPLIER_FOR_INTEGRATION', { name: 'Burson EzyParts' }), 'success');
      });
    },
    search ( typed : string ) {
      const self = this;

      return streamSearch.search('vendors', typed)
      .then(( vendors : Array<VendorModel> ) => self.list.concat(vendors));
    },
    selected: {
      company_name: bursonApi.getVendorName(),
      id          : $scope.settings.burson_ezyparts_vendor_id
    },
    templateUrl: VendorSearchResultsHtml
  };

  $scope.activate = function () {
    confirm.generic($translate.instant('JS_SPACE.INTEGRATIONS.ACTIVATE', { name: 'Burson EzyParts' }))
    .then(() => bursonApi.activate())
    .then(() => {
      messages.show($translate.instant('JS_SPACE.INTEGRATIONS.ACTIVATED', { name: 'Burson EzyParts' }), 'success');

      $state.reload();
    })
    .catch(err => {
      messages.error(err);
    });
  };

  $scope.deactivate = function () {
    confirm.generic($translate.instant('JS_SPACE.INTEGRATIONS.DEACTIVATE', { name: 'Burson EzyParts' }))
    .then(() => bursonApi.deactivate())
    .then(() => {
      $state.reload();
    })
    .catch(err => {
      messages.error(err);
    });
  };

  $scope.isUpgraded = function () : boolean {
    return bursonApi.isUpgraded($scope.settings);
  };

  $scope.save = function () {
    bursonApi.saveSettings($scope.settings, $scope.user)
    .then(() => {
      messages.show($translate.instant('JS_SPACE.MESSAGES.SAVED.SETTINGS'), 'success');

      $scope.form.$setPristine();

      $state.reload();
    })
    .catch(err => {
      messages.error(err);
    });
  };

  $scope.shouldShowAutoDownloadMessage = function () {
    return $rootScope.Company.country('australia')
      && $scope.settings.import_invoices_from_bursons;
  };
}
